<template>
  <div>
    <!--    <v-dialog v-model="this.$store.state.spinning" width="60%" height="60%">-->
    <!--      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">-->
    <!--        <v-layout justify-center align-center>-->
    <!--          <v-progress-circular-->
    <!--              size="100"-->
    <!--              indeterminate-->
    <!--              :color="color">-->
    <!--          </v-progress-circular>-->
    <!--        </v-layout>-->
    <!--      </v-container>-->
    <!--    </v-dialog>-->
    <modal
      id="loading-modal"
      :show="this.$store.state.spinning"
      :centered="false"
      :show-close="true"
      class="modal-info"
    >
      <v-progress-circular
        :color="color"
        size="100"
        indeterminate/>
    </modal>

    <transition mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<style lang="scss">
	@import "@/styles/index.scss";

	/* Remove in 1.2 */
	.v-datatable thead th.column.sortable i {
		vertical-align: unset;
	}
</style>
<script>
import { mapState } from 'vuex'
import Modal from '@/components/Modal'
import { CollapseTransition } from 'vue2-transitions'
import axios from "axios";

// checks to see if auth jwt token is valid or has expired, if it gets back 401 error log out
export default {
  components: {
    CollapseTransition,
    Modal
  },
  computed: {
    ...mapState('app', ['color'])
  },
  created: function () {
    this.$http.interceptors.response.use((response) => {
      return response
    }, (error) => {
      this.$store.state.spinning = false
      if (error.response.status === 401) {
        // if (this.$store.getters.authorized) {
        //   this.$store.dispatch('refreshtoken')
        // } else {
        this.$cookies.set('token', '', '2m', '/', process.env.VUE_APP_API_COOKIE_DOMAIN || '.lfstraining.com')
        delete axios.defaults.headers.common['Authorization']
        // this.$router.push('/')
        // this.$message.error('已登出')
        return Promise.reject(error)
        // }
      } else {
        return Promise.reject(error)
      }
    })
  },
  mounted () {
    this.$watch('$sidebar.showSidebar', this.toggleNavOpen)
  },
  methods: {
    toggleNavOpen () {
      let root = document.getElementsByTagName('html')[0]
      root.classList.toggle('nav-open')
    }
  }
}
</script>
<style>
</style>
